
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IconButton from "@/components/UI/IconButton.vue";
import { uiStore, configStore } from "@/store/store";
import { BASE_BREAKPOINT_ID } from "@/lib/breakpoints/breakpoints";

export const PHONE_PORTRAIT_BREAKPOINT_ID = "breakpoint_phone_portrait";

@Component({
  components: {
    IconButton
  }
})
export default class TopNavToggleMobile extends Vue {
  get currentBreakpoint() {
    return uiStore.currentBreakpoint.id;
  }

  get isMobile() {
    return uiStore.currentBreakpoint.id === PHONE_PORTRAIT_BREAKPOINT_ID;
  }

  toggleMobileBreakpoint() {
    const breakpoint = this.isMobile
      ? configStore.breakpoints.find(b => b.id === BASE_BREAKPOINT_ID)
      : configStore.breakpoints.find(
          b => b.id === PHONE_PORTRAIT_BREAKPOINT_ID
        );

    if (!breakpoint) return;

    uiStore.changeBreakpoint(breakpoint);
  }
}
